import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { AxiosError } from 'axios'
import AuthApi from '../../api/auth/AuthApi'
import { HttpError } from '../../types/common'
import { showErrorToast } from '../../utils/errors'
import { useNavigate } from 'react-router-dom'
import { queryNames } from '../queries'

const authApi = AuthApi.getInstance()

export function useCheckPwdResetToken(token: string, enabled: boolean) {
  const texts = useTranslation().t
  const navigate = useNavigate()

  const query = useQuery(
    [queryNames.checkResetPasswordToken, token],
    () => authApi.checkResetPasswordToken({ token: token }),
    {
      onError: (error: AxiosError<HttpError>) => {
        showErrorToast(error, texts)
        navigate('/', { replace: true })
      },
      enabled: enabled,
      retry: false
    })
  return query
}